import { Box, Button, Card, Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { useLocalization } from 'localization';
import GoogleMapViewer from 'components/v2/maps/GoogleMapViewer';
import ContinueAndPreviewContainer from 'components/v2/container/ContinueAndPreviewContainer';
import { ArrowRightIcon } from 'components/v2/icons/ArrowRightIcon';
import { colors } from 'theme/mui/colors';
import AdsPreview from 'components/v2/shared/AdsPreview';
import notifyHandler from 'utils/notifyHandler';

const CreateAdsCampaignOrderStep5 = () => {
  const { t } = useLocalization();
  const { control, watch } = useFormContext();

  const handleLaunchCampaign = () => {
    notifyHandler({ type: 'success', content: 'Campaign launched successfully!' });
  };

  const mockData = [
    {
      label: 'Display ads',
      value: '25%',
    },
    {
      label: 'Social media ads',
      value: '75%',
    },
    {
      label: 'Start date',
      value: '25%',
    },
    {
      label: 'End date',
      value: '25%',
    },
    {
      label: 'Campaign duration',
      value: '25%',
    },
  ];

  return (
    <Stack direction="row" justifyContent="space-between" sx={{ height: '100%' }}>
      <Stack sx={{ width: '100%', padding: '1rem 1rem 1rem 0', overflowY: 'auto' }} mb={{ xs: 10, md: 0 }} gap={2}>
        <Stack gap={1.5}>
          <Typography variant="h3">{t('orders.pages.new.ads.confirmAdSetup')}</Typography>
          <Typography variant="body1">
            Review your ad details, targeting, and schedule before publishing. Make any final adjustments to ensure your
            real estate campaign is accurate and ready to reach the right audience.
          </Typography>
        </Stack>
        <Card sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
          <img
            src="https://imageresizing.esoft.com/?width=1200&height=1200&format=webp&quality=75&fit=contain&image=https://cdn-m2.esoftsystems.com/10100603/DREJEB%C3%86NKEN+22%2C+5260+ODENSE+S/10225159504/827095412/ORIGINAL/DJI-20250703100412-0037-D.jpg"
            alt="mock"
            width={64}
            height={64}
            style={{ borderRadius: '8px' }}
          />
          <Typography variant="h5">Glaciset 10B, 1, 2800, Kongens Lyngby'</Typography>
        </Card>

        <Card sx={{ display: 'flex', gap: 1 }}>
          <Typography variant="h5">EFKT Property Basic</Typography>
          {mockData.map((item, index) => {
            return (
              <Stack
                direction="row"
                justifyContent="space-between"
                sx={{ backgroundColor: colors.base.level20, borderRadius: '0.5rem' }}
                padding="0.75rem"
                key={index}
              >
                <Typography variant="h5" fontSize="0.875rem">
                  {item.label}
                </Typography>
                <Typography variant="h5" fontSize="0.875rem" sx={{ color: colors.base.level60 }}>
                  {item.value}
                </Typography>
              </Stack>
            );
          })}
        </Card>

        <Box sx={{ width: '100%', height: '100%' }}>
          <GoogleMapViewer lng={watch('longitude')} lat={watch('latitude')} zoom={15} />
        </Box>
      </Stack>

      <ContinueAndPreviewContainer
        continueElement={
          <Stack gap={2}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ display: { xs: 'none', sm: 'flex' } }}
            >
              <Typography variant="h4">{t('common.terms.totalPrice')}</Typography>
            </Stack>
            <Button
              size="large"
              // loading={isLoading || orderLoading}
              onClick={handleLaunchCampaign}
              variant="contained"
              fullWidth
              endIcon={<ArrowRightIcon />}
              sx={{ minWidth: 'fit-content' }}
            >
              {t('orders.pages.new.ads.confirmAndLaunchCampaign')}
            </Button>
          </Stack>
        }
        previewElement={
          <AdsPreview
            loading={false}
            src={
              'https://imageresizing.esoft.com/?width=1200&height=1200&format=webp&quality=75&fit=contain&image=https://cdn-m2.esoftsystems.com/10100603/DREJEB%C3%86NKEN+22%2C+5260+ODENSE+S/10225159504/827095412/ORIGINAL/DJI-20250703100412-0037-D.jpg'
            }
          />
        }
      />
    </Stack>
  );
};

export default CreateAdsCampaignOrderStep5;
